import client from '@/shared/apis/client'
import { SoapRule } from '@/features/internal/soap-rules/types/soapRule'

const BASE_URL = '/api/soap-rules'

export class SoapRuleAPI {
  async getRules(): Promise<SoapRule[]> {
    const response = await client.get<{
      count: number
      results: SoapRule[]
    }>(`${BASE_URL}/`)
    return response.data.results
  }

  async createRule(
    rule: Omit<SoapRule, 'id' | 'created_at'>
  ): Promise<SoapRule> {
    const response = await client.post<SoapRule>(`${BASE_URL}/`, rule)
    return response.data
  }

  async updateRule(id: string, rule: Partial<SoapRule>): Promise<SoapRule> {
    const response = await client.patch<SoapRule>(`${BASE_URL}/${id}/`, rule)
    return response.data
  }

  async deleteRule(id: string): Promise<void> {
    await client.delete(`${BASE_URL}/${id}/`)
  }
}

export const soapRuleAPI = new SoapRuleAPI()
